import PAPER_ICON from "@/assets/icons/paper.svg";
import PAPER_RED from "@/assets/icons/paper-red-border.svg";
import { ReactComponent as TRASH_ICON } from "@/assets/icons/trash.svg";
import "./style.scss";
import { FC } from "react";

interface UploadingItem {
  fileType: string;
  fileName: string;
  fileSize: string;
  percentage: number;
  isFail: boolean;
  onTryAgain?: () => void;
  onRemove?: () => void;
  width?: string;
}

const UploadingItem: FC<UploadingItem> = ({
  fileType,
  fileName,
  fileSize,
  percentage,
  isFail,
  onTryAgain = () => {},
  onRemove = () => {},
  width = "calc(100% - 54px)",
}) => {
  return (
    <div
      className={"uploading-item-wrapper" + (isFail ? " failed" : "")}
      style={{ width }}
    >
      <div className="icon-section">
        <img src={isFail ? PAPER_RED : PAPER_ICON} alt="paper" />
        <div className="file-type">
          <span className="type-text">{fileType}</span>
        </div>
      </div>

      <div className="file-info-section">
        <span className="file-name">{fileName}</span>
        {isFail ? (
          <span className="desc">Upload failed, please try again</span>
        ) : (
          <span className="desc">
            {fileSize} – {percentage}% uploaded
          </span>
        )}

        {isFail && (
          <div
            className="file-name"
            style={{ marginTop: "4px", cursor: "pointer" }}
            onClick={onTryAgain}
          >
            Try again
          </div>
        )}
      </div>

      {isFail && (
        <button className="trash-btn" onClick={onRemove}>
          <TRASH_ICON />
        </button>
      )}
    </div>
  );
};

export default UploadingItem;
